import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "px-6" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "text-lg leading-6 font-medium text-gray-900" }
const _hoisted_5 = { class: "text-sm text-gray-500 mt-1" }
const _hoisted_6 = { class: "text-sm text-gray-500 mt-1" }
const _hoisted_7 = { class: "text-sm text-gray-500 mt-1" }
const _hoisted_8 = { class: "text-sm text-gray-500 mt-1 mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "py-2" }, null, -1)
const _hoisted_10 = { class: "my-4 flex justify-center gap-8" }
const _hoisted_11 = {
  type: "submit",
  class: "flex-1 bg-blue-500 text-white p-1 px-4 rounded"
}
const _hoisted_12 = {
  key: 1,
  class: "h-96"
}
const _hoisted_13 = { class: "w-full h-full grid grid-cols-1 place-items-center" }

import { useStore } from 'vuex'
import { computed, onMounted, ref, shallowRef, watch } from 'vue'
import { getTicketTopics } from '@/utils/ticket-config'
import DialogComponent from '@/components/doalog/DialogComponent.vue'
import DropdownComponent from '@/components/tools/DropdownComponent.vue'
/** ticket form components */
import UpdateChangeRoleAdmin from './UpdateChangeRoleAdmin.vue'
import CheckBetSetted from './CheckBetSetted.vue'
import ChangeUsername from './ChangeUsername.vue'
import InactiveUserAdmin from './inactiveUserAdmin.vue'
import CreateNewUserAdmin from './CreateNewUserAdmin.vue'
import ChangeBankAccountName from './ChangeBankAccountName.vue'
import ChangeBankAccountNo from './ChangeBankAccountNo.vue'
import BetNotSettled from './BetNotSettled.vue'
import AddRemoveOperationList from './AddRemoveOperationList.vue'
import UpdateLineOa from './UpdateLineOa.vue'
import CantPlaygame from './CantPlaygame.vue'
import CheckCommissionAffiliate from './CheckCommissionAffiliate.vue'
import ClearHoldBalance from './ClearHoldBalance.vue'
import RequestChangeUsernamePasswordAdmin from './RequestChangeUsernamePasswordAdmin.vue'
import AdminRequestResetgoogleAuth from './AdminRequestResetgoogleAuth.vue'
import AdminRequestResetMobileNo from './AdminRequestResetMobileNo.vue'
import CantUseCms from './CantUseCms.vue'
import DepositAndWithdrawnCms from './DepositAndWithdrawnCms.vue'
import UpdateWithdrawLimit from './UpdateWithdrawLimit.vue'
import UpdateValidBalance from './UpdateValidBalance.vue'
import LoyaltyPoint from './LoyaltyPoint.vue'
import Other from './Other.vue'

interface UserInfo {
  id: string
  accountNameTh: string
  username: string
  phoneNumber: string
  bankCode: string
  accountNumber: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateTicketBaseDialog',
  props: { loading: Boolean, show: Boolean, userInfo: Object as () => UserInfo, isPlayer: Boolean },
  emits: ['update:loading', 'update:show', 'onCreateTicket'],
  setup(__props, { emit }) {

const props = __props



const store = useStore()
const loadingSync = computed({ get: () => props.loading, set: (val) => emit('update:loading', val) })

const form = ref()
const ticketTopicOptions = ref<{ label: string; value: string }[]>()
const selectedTicketTopic = ref<{ label: string; value: string }>()

const topicComponent = shallowRef()

const setTopicComponent = (name: string) => {
  switch (name) {
    case 'updateChangeRoleAdmin':
      topicComponent.value = UpdateChangeRoleAdmin
      break
    case 'checkBetSettled':
      topicComponent.value = CheckBetSetted
      break
    case 'changeBankAccountName':
      topicComponent.value = ChangeBankAccountName
      break
    case 'changeUsername':
      topicComponent.value = ChangeUsername
      break
    case 'inactiveUserAdmin':
      topicComponent.value = InactiveUserAdmin
      break
    case 'createNewUserAdmin':
      topicComponent.value = CreateNewUserAdmin
      break
    case 'changeBankAccountNo':
      topicComponent.value = ChangeBankAccountNo
      break
    case 'betNotSettled':
      topicComponent.value = BetNotSettled
      break
    case 'addRemoveOperationList':
      topicComponent.value = AddRemoveOperationList
      break
    case 'updateLineOa':
      topicComponent.value = UpdateLineOa
      break
    case 'cantPlaygame':
      topicComponent.value = CantPlaygame
      break
    case 'checkCommissionAffiliate':
      topicComponent.value = CheckCommissionAffiliate
      break
    case 'clearHoldBalance':
      topicComponent.value = ClearHoldBalance
      break
    case 'requestChangeUsernamePasswordAdmin':
      topicComponent.value = RequestChangeUsernamePasswordAdmin
      break
    case 'adminRequestResetgoogleAuth':
      topicComponent.value = AdminRequestResetgoogleAuth
      break
    case 'adminRequestResetMobileNo':
      topicComponent.value = AdminRequestResetMobileNo
      break
    case 'cantUseCms':
      topicComponent.value = CantUseCms
      break
    case 'depositAndWithdrawnCms':
      topicComponent.value = DepositAndWithdrawnCms
      break
    case 'updateWithdrawLimit':
      topicComponent.value = UpdateWithdrawLimit
      break
    case 'updateValidBalance':
      topicComponent.value = UpdateValidBalance
      break
    case 'loyaltyPoint':
      topicComponent.value = LoyaltyPoint
      break
    case 'other':
      topicComponent.value = Other
      break
  }
}

const onCreateTicket = () => {
  loadingSync.value = true
  const formData = new FormData(form.value)
  const valueFromData = Object.fromEntries(formData.entries())
  const descriptionPayload = []
  for (const [key, value] of Object.entries({ ...valueFromData, operator_name: store.state.selectedOperator.name, admin_name: store.state.user.username })) {
    if (typeof value !== 'object') {
      descriptionPayload.push({ insert: `${key}: ${value}` })
      descriptionPayload.push({ insert: `\n` })
    }
  }
  
  const payload = {
    user_id: props.userInfo?.id || valueFromData?.userid || '',
    case: selectedTicketTopic.value?.label,
    admin_id: store.state.user.id,
    admin_name: store.state.user.username,
    operator_id: store.state.selectedOperator.operatorId,
    operator_name: store.state.selectedOperator.name,
  }


  formData.append('description', JSON.stringify({ ops: descriptionPayload }))
  Object.keys(payload).forEach((key) => formData.append(key, payload[key as keyof typeof payload]))
  emit('onCreateTicket', { formData, form_name: selectedTicketTopic.value?.value })
}

watch(selectedTicketTopic, () => {
  if (!selectedTicketTopic.value) return
  setTopicComponent(selectedTicketTopic.value.value)
})

onMounted(() => {
  /** TODO: handler topic permissions */
  try {
    const ticketTopics = getTicketTopics(store.state.user, props.isPlayer)
    ticketTopicOptions.value = ticketTopics
    selectedTicketTopic.value = ticketTopics[0]
  } catch (error) {
    console.log(error)
  }
})


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(DialogComponent, {
    title: _ctx.$t('messages.ticketManagement.createTicket'),
    isOpen: __props.show
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!__props.loading)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              enctype: "multipart/form-data",
              ref_key: "form",
              ref: form,
              action: "",
              onSubmit: _withModifiers(onCreateTicket, ["prevent"])
            }, [
              (__props.userInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("h3", _hoisted_4, _toDisplayString(__props.userInfo && __props.userInfo.accountNameTh ? __props.userInfo.accountNameTh : '-'), 1),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('messages.player.id.username')) + ": " + _toDisplayString(__props.userInfo && __props.userInfo.username ? __props.userInfo.username : '-'), 1),
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('messages.player.id.mobile')) + ": " + _toDisplayString(__props.userInfo && __props.userInfo.phoneNumber ? __props.userInfo.phoneNumber : '-'), 1),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('messages.player.id.bank')) + ": " + _toDisplayString(__props.userInfo && __props.userInfo.bankCode ? __props.userInfo.bankCode : '-'), 1),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('messages.player.id.accountNumber')) + ": " + _toDisplayString(__props.userInfo && __props.userInfo.accountNumber ? __props.userInfo.accountNumber : '-'), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.ticketTopic')) + " ", 1),
                _createVNode(DropdownComponent, {
                  class: "w-full",
                  options: ticketTopicOptions.value,
                  modelValue: selectedTicketTopic.value,
                  onOnOptionSelected: _cache[0] || (_cache[0] = (option) => (selectedTicketTopic.value = option))
                }, null, 8, ["options", "modelValue"])
              ]),
              _hoisted_9,
              _createElementVNode("div", null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(topicComponent)), {
                  username: __props.userInfo?.username
                }, null, 8, ["username"]))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "flex-1 bg-red-500 text-white p-1 px-4 rounded",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:show', false)))
                }, _toDisplayString(_ctx.$t('messages.ticketManagement.cancel')), 1),
                _createElementVNode("button", _hoisted_11, _toDisplayString(_ctx.$t('messages.ticketManagement.createTicket')), 1)
              ])
            ], 40, _hoisted_2))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_font_awesome_icon, {
                  class: "text-gray-500",
                  icon: ['fas', 'circle-notch'],
                  transform: "grow-6",
                  spin: ""
                })
              ])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["title", "isOpen"]))
}
}

})